import { render, staticRenderFns } from "./vp67.vue?vue&type=template&id=bc908ede&scoped=true"
import script from "./vp67.vue?vue&type=script&lang=js"
export * from "./vp67.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc908ede",
  null
  
)

export default component.exports